import {useEffect, useState} from "react";

const NavigationSelector = ({
                                CampaignsDefaultNavigationWrapper,
                                CampaignsPlatformNavigationWrapper,
                                showCjPlatformNav
                            }) => {
    const [cjPlatformNav, setCjPlatformNav] = useState(undefined);

    useEffect(() => {
        showCjPlatformNav().then(isCjPlatformNav => {
            setCjPlatformNav(isCjPlatformNav)
        });
    }, [])

    return cjPlatformNav === true
        ? <CampaignsPlatformNavigationWrapper/>
        : (cjPlatformNav === false && <CampaignsDefaultNavigationWrapper/>)
}

export default NavigationSelector;